import React, { Component } from 'react';
import './../css/master.css';
import './../css/report.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';

var httpURL = '';
var queryString = require('querystring');
var lstReports =[];
var monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

class Report extends Component {
  constructor(props){
		super(props);
		this.state={
			report:[],
			endDate:null,
			startDate:null,
			month1:'-',
			month2:'-',
			month3:'-',
			month4:'-',
			month5:'-',
			month6:'-',
			btnText:'Expand All',
			disabled:true,
			maxDate:null,
			loader:'none',
			opacity:1,
			width:'97.6%',
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleChange1 = this.handleChange1.bind(this);
	}
  
  async handleChange(date){
		var startDate = date.setMonth(date.getMonth());
		var endDate = date.setMonth(date.getMonth()+5);
		await this.setState({
			startDate: new Date(startDate),
			endDate:new Date(endDate),
			maxDate:new Date(endDate),
		});
	}
  handleChange1(date){
    this.setState({
      endDate: date
    });
  }
  
  async componentDidMount(){
	 var date =  new Date();
	 var endDate = date.setMonth(date.getMonth());
	 var startDate = date.setMonth(date.getMonth()-5);
	 await this.setState({
		 startDate:new Date(startDate),
		 endDate:new Date(endDate),
		 maxDate:new Date(endDate),
	 });
	 
	 this.getReport();
	 this.handleResize();
	 window.addEventListener("load", this.handleResize);
	 window.addEventListener("resize", this.handleResize);
 }
 
 handleResize=()=>{
	var width = ($('.tableLayout1').parent().width())-17;
	this.setState({width:width});
 }

 getReport =()=> {
	var fromDate = $('#inp_fromDate').val();
	var toDate = $('#inp_toDate').val();
	this.setMonth(new Date(this.state.startDate), new Date(this.state.endDate));
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/a/ipo/report/list', 
		queryString.stringify({'fromDt':fromDate,'toDt':toDate}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
				lstReports=response.data.report;
				this.setReportTable();
				this.setState({loader:'none', opacity:1, disabled:false});
		}
		else{
			toast.error(response.data.SvcMsg)
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
			this.setState({loader:'none', opacity:1});
		}
	}).catch((e)=>{
		toast.error("Service failed "+e);
	});
}

setMonth =(startDate, endDate)=>{
	var arr = [];
  var datFrom = startDate;
  var datTo = endDate;
  var fromYear =  startDate.getFullYear();
  var toYear =  endDate.getFullYear();
  var diffYear = (12 * (toYear - fromYear)) + datTo.getMonth();
	for (var i = datFrom.getMonth(); i <= diffYear; i++) {
      arr.push(monthArray[i%12]+ " " + Math.floor(fromYear+(i/12)));
  }        

  this.setState({
		month1:arr[0] == undefined ? '-' : arr[0],
		month2:arr[1] == undefined ? '-' : arr[1],
		month3:arr[2] == undefined ? '-' : arr[2],
		month4:arr[3] == undefined ? '-' : arr[3],
		month5:arr[4] == undefined ? '-' : arr[4],
		month6:arr[5] == undefined ? '-' : arr[5],
	});
}
// triggerUploadFile(){

// //	$('#uploadFile').trigger('click');

// 	$("#export").click(function (e) {
// 		window.open('data:application/vnd.ms-excel,' + $('#reportTable').text());
// 		e.preventDefault();

// 	});
// }
 
setReportTable =()=> {
	$('#reportTableBody tr').remove();
	var table 			= document.getElementById('reportTable');
	var tbody 			= document.getElementById('reportTableBody');
	var filterWeaver    = $('#filterWeaver').val().toLowerCase();	
	for(var i=0; i<lstReports.length; i++){
		var weaverId				= lstReports[i].weaverId;
		var weaver					= lstReports[i].weaver;
		var wMonth1   			    = lstReports[i].month1 == 0 ? '-' : lstReports[i].month1;
		var wMonth2					= lstReports[i].month2 == 0 ? '-' : lstReports[i].month2;
		var wMonth3					= lstReports[i].month3 == 0 ? '-' : lstReports[i].month3;
		var wMonth4					= lstReports[i].month4 == 0 ? '-' : lstReports[i].month4;
		var wMonth5					= lstReports[i].month5 == 0 ? '-' : lstReports[i].month5;
		var wMonth6					= lstReports[i].month6 == 0 ? '-' : lstReports[i].month6;
		var wTotalQuantity	        = lstReports[i].totalQuantity == 0 ? '-' : lstReports[i].totalQuantity;
		var lstReport				= lstReports[i].lstReport;
		
		var row = document.createElement('tr');
		row.id = 'weaver-'+weaverId;
		row.addEventListener('click', this.toggleRows);
		if(i%2 == 0){
			row.style.backgroundColor = 'rgb(230, 227, 224)' //'#b5e2b2';
		}else{
			row.style.backgroundColor = 'rgb(230, 227, 224)' //'#d5f3d3';
		}
		row.style.fontWeight = 'bold';
		//row.style.color = '#22841c';
		if(weaver.toLowerCase().indexOf(filterWeaver) == -1)
			continue;

		this.addTD(row, weaverId, 'no-display');
		this.addTD(row, weaver, 'text-left');
		this.addTD(row, wMonth1.toLocaleString('en-IN'), 'text-right');
		this.addTD(row, wMonth2.toLocaleString('en-IN'), 'text-right');
		this.addTD(row, wMonth3.toLocaleString('en-IN'), 'text-right');
		this.addTD(row, wMonth4.toLocaleString('en-IN'), 'text-right');
		this.addTD(row, wMonth5.toLocaleString('en-IN'), 'text-right');
		this.addTD(row, wMonth6.toLocaleString('en-IN'), 'text-right');
		this.addTDBackground(row, wTotalQuantity.toLocaleString('en-IN'), 'text-right');
		tbody.append(row);
		$(row).find("td").attr({width:"100",position:"absolute",align:"center"});
		for(var j=0; j<lstReport.length; j++){
			var machineTypeId		= lstReport[j].machineTypeId;
			var machineType			= lstReport[j].machineType;
			var rMonth1   			= lstReport[j].month1 == 0 ? '-' : lstReport[j].month1;
			var rMonth2					= lstReport[j].month2 == 0 ? '-' : lstReport[j].month2;
			var rMonth3					= lstReport[j].month3 == 0 ? '-' : lstReport[j].month3;
			var rMonth4					= lstReport[j].month4 == 0 ? '-' : lstReport[j].month4;
			var rMonth5					= lstReport[j].month5 == 0 ? '-' : lstReport[j].month5;
			var rMonth6					= lstReport[j].month6 == 0 ? '-' : lstReport[j].month6;
			var rTotalQuantity	= lstReport[j].totalQuantity == 0 ? '-' : lstReport[j].totalQuantity;
			
			var row1 = document.createElement('tr');
			row1.style.display = 'none';
			row1.style.backgroundColor = '#fbfbfb';
			row1.className = 'weaverRow';
			if(j == lstReport.length-1){
				row1.style.borderBottom = '2px solid gray';
			}
			//row1.style.color = '#2fc509';
			row1.style.fontStyle = 'normal';
			row1.className = 'report-'+weaverId + ' toggleRow';
			
			this.addTD(row1, machineTypeId, 'no-display');
			this.addTD(row1, machineType, 'text-left');
			this.addTD(row1, rMonth1.toLocaleString('en-IN'), 'text-right');
			this.addTD(row1, rMonth2.toLocaleString('en-IN'), 'text-right');
			this.addTD(row1, rMonth3.toLocaleString('en-IN'), 'text-right');
			this.addTD(row1, rMonth4.toLocaleString('en-IN'), 'text-right');
			this.addTD(row1, rMonth5.toLocaleString('en-IN'), 'text-right');
			this.addTD(row1, rMonth6.toLocaleString('en-IN'), 'text-right');
			this.addTDBackground(row1, rTotalQuantity.toLocaleString('en-IN'), 'text-right');
			tbody.append(row1);
			$(row1).find("td").attr({width:"100",position:"absolute",align:"center"});
		}
	}
	table.append(tbody);
	var ab =document.createElement('tr');
	var td0 =document.createElement('td');
	var td1 =document.createElement('td');
	var td2 =document.createElement('td');
	var td3 =document.createElement('td');
	var td4 =document.createElement('td');
	var td5 =document.createElement('td');
	var td6 =document.createElement('td');
	var td7 =document.createElement('td');
	var td8 =document.createElement('td');
	
	td0.innerHTML='WeaverId';
	td1.innerHTML='Weaver';
	td2.innerHTML=this.state.month1;
	td3.innerHTML=this.state.month2;
	td4.innerHTML=this.state.month3;
	td5.innerHTML=this.state.month4;
	td6.innerHTML=this.state.month5;
	td7.innerHTML=this.state.month6;
	td8.innerHTML='Total';
	ab.append(td0);
	ab.append(td1);
	ab.append(td2);
	ab.append(td3);
	ab.append(td4);
	ab.append(td5);
	ab.append(td6);
	ab.append(td7);
	ab.append(td8);
	$(ab).find("td").hide().attr({width:"100",position:"absolute",align:"center"});
	$(ab).css({"backgroundColor":"black","color":"white"});
	tbody.prepend(ab);
	
}
	
		
addTD(row, val, classname){
	var cell = document.createElement('td');
	if(val != '-'){
		cell.className = classname;
	}else{
		cell.className = 'text-center';
	}
	var text = document.createTextNode(val);
	cell.append(text);
	row.append(cell);
}

addTDBackground(row, val, classname){
	var cell = document.createElement('td');
	cell.style.backgroundColor = 'rgba(191, 187, 182, 1)'; //'#6ac56a'
	cell.style.fontSize = '13px';
	if(val != '-'){
		cell.className = classname;
	}else{
		cell.className = 'text-center';
	}
	var text = document.createTextNode(val);
	cell.append(text);
	row.append(cell);
}

toggleRows(e){
	var rowId = $(e.target).closest('tr').attr('id').split('-')[1];
	$('.report-'+rowId).toggle();
}

expandAll=()=>{
	if(this.state.btnText == 'Expand All'){
		$(".toggleRow").show();
		this.setState({btnText:'Collapse All'});
	}else{
		$(".toggleRow").hide();
		this.setState({btnText:'Expand All'});
	}
}

render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader, zIndex:9999}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div>
			
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-12 col-centered">
						<div className="col-sm-5 col-centered"  style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', marginBottom:10}}>
							<div style={{width:100}} className="text-center">
								<label htmlFor="inp_fromDate">From Date</label>
							</div>
							<div style={{width:100}} className="text-center">
								<DatePicker id="inp_fromDate"
									className='form-control text-center'
									placeholderText="From Date"
									selected={this.state.startDate}
									onChange={this.handleChange}
									dateFormat="yyyy-MM"
									autoComplete='off'
									showMonthYearPicker
								/>
							</div>
							<div style={{width:100}} className="text-center">
								<label htmlFor="inp_toDate">To Date</label>
							</div>
							<div style={{width:100}} className="text-center">
								<DatePicker id="inp_toDate"
									className='form-control text-center'
									placeholderText="To Date"
									selected={this.state.endDate}
									onChange={this.handleChange1}
									dateFormat="yyyy-MM"
									minDate={this.state.startDate}
									maxDate={this.state.maxDate}
									autoComplete='off'
									showMonthYearPicker
								/>
							</div>
							<div className="pull-right">
								<button style={{marginRight:20,marginLeft:20}} type="button" className="btn btn-warning" onClick={this.getReport} id="getReport">Get</button>
							</div>
							{/* <div className="pull-left">
								<ReactHTMLTableToExcel
										id="test-table-xls-button"
										className="btn btn-warning xls-button"
										table="reportTable"
										filename="tablexls"
										sheet="tablexls"
										buttonText="Export"
									/>
							</div> */}
						</div>
						<div className="row col-sm-8 col-centered">
							<button type="button" onClick={this.expandAll} disabled={this.state.disabled} className="btn btn-warning btn-xs">{this.state.btnText}</button>
							<table id="tableHeadReport" className="tableLayout1" style={{width:this.state.width}}>
								<thead>
									<tr>
										<th style={{width:50,display:'none'}}>Weaver Id</th>
										<th style={{width:120}}>
											<input style={{fontSize:12}} type="text" onChange={this.setReportTable} id="filterWeaver" placeholder="Weaver" className="form-control"/>
										</th>
										<th style={{width:50}}>{this.state.month1}</th>
										<th style={{width:50}}>{this.state.month2}</th>
										<th style={{width:50}}>{this.state.month3}</th>
										<th style={{width:50}}>{this.state.month4}</th>
										<th style={{width:50}}>{this.state.month5}</th>
										<th style={{width:50}}>{this.state.month6}</th>
										<th style={{width:50}}>Total</th>
									</tr>
								</thead>
							</table>
							<div className="reportTableDiv">
								<table id="reportTable" className="tableLayout">
									<colgroup>
										<col style={{width:120}} />
										<col style={{width:50}} />
										<col style={{width:50}} />
										<col style={{width:50}} />
										<col style={{width:50}} />
										<col style={{width:50}} />
										<col style={{width:50}} />
										<col style={{width:50}} />
									</colgroup>
									<tbody id="reportTableBody"></tbody>
									</table>
								
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default Report;
